export default __webpack_public_path__ + "static/media/a017-market-10.ee8e121b.svg";